<template>
  <div>
    <div class="sayfahead tek" v-if="Bina">
      <h1>{{ Bina.Adi }}</h1>
      <el-button-group class="float-right YeniBtn">
        <el-button type="danger" size="small" @click="BinaSil">Sil</el-button>
        <el-button type="primary" size="small" @click="Modal=true">Düzenle</el-button>
        <el-button type="info" size="small" @click="SayfaYukle">Yenile</el-button>
      </el-button-group>
    </div>
    <div class="icerik" style="height: calc(100vh + 120px) !important;">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-row :gutter="24" v-if="!lo">
        <EsayacBinaKurulum :Bina_id="Bina_id" v-if="!Kurulum"></EsayacBinaKurulum>
        <EsayacBinaEkran @Yenile="this.SayfaYukle" :Bina="Bina" :Excel="Excel" :Donem="Donem" :Fatura="Fatura"
                         :Mesken="Mesken"
                         v-if="Kurulum" :ExcelTelegram="ExcelTelegram"></EsayacBinaEkran>
      </el-row>
      <el-dialog
        append-to-body
        v-if="Modal"
        :title="Bina.Adi+' Düzenle'"
        :visible="Modal"
        center
        width="60%">
        <a @click="Modal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
        <el-form :model="Bina" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
          <el-row :gutter="24">
            <el-col :span="Hesap_id==6?11:14">
              <el-form-item label="Site/Bina Adı" prop="Adi">
                <el-input v-model="Bina.Adi"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Aidatım Kodu" prop="AVT">
                <el-input v-model="Bina.AVT"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Aidatım Bina İD" prop="ABinaId">
                <el-input v-model="Bina.ABinaId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" v-if="Hesap_id==6">
              <el-form-item label="Cari Hesap Kodu" prop="EntegreKodu">
                <el-input v-model="Bina.EntegreKodu"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Okuma Gün" prop="oGun">
                <el-input v-model="Bina.oGun"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="21">
              <el-form-item label="Açıklama" prop="Aciklama">
                <el-input v-model="Bina.Aciklama"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Durum" prop="Durum">
                <el-switch v-model="Bina.Durum"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Adres" prop="Adres">
                <el-input type="textarea" v-model="Bina.Adres"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Fatura" prop="OkumaUcreti">
                <el-input v-model="Bina.OkumaUcreti"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Tahsilat" prop="TahsilUcreti">
                <el-input v-model="Bina.TahsilUcreti"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="İlgili Ad Soyad" prop="Ilgili">
                <el-input v-model="Bina.Ilgili"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="İlgili Telefon" prop="Iletisim">
                <el-input v-model="Bina.Iletisim" v-mask="'### ### ## ##'"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Referans No" prop="Referans">
                <el-input type="email" v-model="Bina.Referans"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="Mail Adresleri" prop="Email">
                <el-input type="email" v-model="Bina.Email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Bölge" prop="Bolge">
                <el-select v-model="Bina.Bolge" filterable>
                  <el-option
                    v-for="item in Bolge"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Koordinat" prop="Koordinat">
                <el-input v-model="Bina.Koordinat"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Vergi Dairesi" prop="vDairesi">
                <el-input v-model="Bina.vDairesi"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Vergi No" prop="vNo">
                <el-input v-model="Bina.vNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider content-position="left">Uzaktan Okuma Ayarları</el-divider>
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="Uzaktan Okuma Cihaz" prop="ufirma">
                <el-select v-model="Bina.ufirma" filterable clearable>
                  <el-option label="Fabsis" value="Fabsis"></el-option>
                  <el-option label="Yapifen" value="Yapifen"></el-option>
                  <el-option label="Wimbus" value="Wimbus"></el-option>
                  <el-option label="Fnf" value="Fnf"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="CCID/IMEI Numarası" prop="ccid">
                <el-input v-model="Bina.ccid"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="medium" :disabled="lo" @click="Submit()" icon="el-icon-check">
            Kaydet
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import EsayacBinaKurulum from "../../../components/Pack/Esayac/EsayacBinaKurulum";
import EsayacBinaEkran from "../../../components/Pack/Esayac/EsayacBinaEkran";
import Yukleniyor from "../../../components/Doc/Yukleniyor";
import {router} from "../../../router";

export default {
  components: {Yukleniyor, EsayacBinaKurulum, EsayacBinaEkran},
  props: ['Bina_id'],
  data() {
    return {
      lo: false,
      Kurulum: false,
      Modal: false,
      Bina: null,
      Hesap_id: null,
      Fatura: null,
      Donem: null,
      Excel: null,
      ExcelTelegram: null,
      Bolge: [
        {id: "1", Adi: '1.Bölge'},
        {id: "2", Adi: '2.Bölge'},
        {id: "3", Adi: '3.Bölge'},
        {id: "4", Adi: '4.Bölge'},
      ],
      FormHata: {
        Adi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Adres: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        OkumaUcreti: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        TahsilUcreti: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Bolge: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      }
    }
  },
  methods: {
    BinaSil() {
      this.$confirm("Binaya ait Fatura, Sayaç , Mesken bilgileri komple silinecektir. <br> İşlemi onaylıyormusunuz?", "Silme Onayı", {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.BinaSilOnay()
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    BinaSilOnay() {
      this.lo = true;
      this.$store.dispatch("Delete", {path: '_enerji/bina/' + this.Bina_id})
        .then(response => {
          this.lo = false
          if (response.Durum === 'OK') {

            router.push("/bina");
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: '_enerji/bina/' + this.Bina_id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Bina = response.Bina;
            this.Mesken = response.Mesken;
            this.Kurulum = response.Kurulum;
            this.Fatura = response.Fatura;
            this.Donem = response.Donem;
            this.Excel = response.Excel;
            this.ExcelTelegram = response.ExcelTelegram;
            this.lo = false
            if(!this.Bina.Durum) this.$message.error("Bina Pasif")
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    Submit() {
      this.lo = true;
      this.$store.dispatch("Put", {...this.Bina, path: '_enerji/bina/' + this.Bina_id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.lo = false;
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
            this.Modal = false
          } else {
            this.lo = false;
            this.$message.error(response.Mesaj);
          }
        });
    }
  },
  created() {
    this.SayfaYukle();
    this.Hesap_id = JSON.parse(localStorage.getItem('_aiHesap'))['id'];
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/_Sayac/Bina/Detay.vue